<template>
  <b-toast id="ph-toast" :variant="variant" :toaster="toaster" solid :no-auto-hide="noautohide" @hidden="onhiddenfunc">
    <template v-slot:toast-title>
      <div class="d-flex flex-grow-1 align-items-baseline">
        <b-icon v-if="false" :icon="phToastTitleIcon" show></b-icon>
        <b-img blank :blank-color="titleVariantColor" class="mr-2" width="12" height="12"></b-img>
        <strong class="mr-auto">{{ title }}</strong>
        <small v-if="false" class="text-muted mr-2">42 seconds ago</small>
      </div>
    </template>
    <span v-html="content"></span>
  </b-toast>
</template>

<script>
import { BIcon } from 'bootstrap-vue';

export default {
  name: 'Toast',
  components: { BIcon },
  computed: {
    phToastTitleIcon() {
      return 'exclamation-triangle';
    },
    titleVariantColor() {
      let color = '';
      switch (this.variant.toLowerCase()) {
        case 'danger':
          color = '#dc3545';
          break;
        case 'warning':
          color = '#ffc107';
          break;
        default:
          color = '#17a2b8';
      }
      return color;
    },
  },
  props: {
    content: {
      type: String,
      required: true,
    },
    noautohide: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'title',
    },
    toaster: {
      type: String,
      default: 'b-toaster-top-right',
    },
    variant: {
      type: String,
      default: 'info',
    },
    onhiddenfunc: {
      type: Function,
      default: function() {
        return null;
      },
    },
  },
};
</script>

<style scoped></style>
